<template>
  <div v-if="pipeline" class="p-12">
    <div class="max-w-7xl mx-auto space-y-8">
      <div>
        <BaseButton
          tag="router-link"
          :to="{
            name: 'accounts.pipelines.pipelineUuid',
            params: {
              accountId,
              pipelineUuid,
            },
          }"
          primary
        >
          Back to pipeline
        </BaseButton>
      </div>
      <PipelineUpdateForm :pipeline="pipeline" />

      <CoverForm :pipeline="pipeline" @changed="fetchPipeline()" />

      <PipelineStagesUpdateForm :pipeline-id="pipeline.id" :pipeline-stages="pipelineStages" />

      <BaseCard>
        <BaseCardHeader>
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">Delete pipeline</h3>
            <p class="max-w-2xl text-sm text-gray-500">Permantly delete this pipeline.</p>
          </div>
        </BaseCardHeader>
        <BaseCardBody>
          <p class="text-gray-800 measure">
            Once a pipeline is deleted, all contacts associated with it will be detached.
          </p>
        </BaseCardBody>
        <BaseCardFooter gray>
          <PipelineDestroyForm :pipeline-id="pipeline.id" @destroyed="handleDestroyed" />
        </BaseCardFooter>
      </BaseCard>
    </div>
  </div>
</template>

<script>
import PipelineUpdateForm from 'Forms/Pipeline/PipelineUpdateForm.vue';
import PipelineStagesUpdateForm from 'Forms/Pipeline/PipelineStagesUpdateForm.vue';
import PipelineDestroyForm from 'Forms/Pipeline/PipelineDestroyForm.vue';
import CoverForm from 'Forms/Pipeline/CoverForm.vue';

export default {
  components: {
    PipelineUpdateForm,
    PipelineStagesUpdateForm,
    PipelineDestroyForm,
    CoverForm,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    pipelineUuid: {
      type: String,
      required: true,
    },
  },
  computed: {
    pipeline() {
      return this.$store.state.entities.pipelines.byId[this.pipelineUuid];
    },
    pipelineStages() {
      const { pipelineStages = [] } = this.pipeline || {};

      const pipelineStagesById = this.$store.state.entities.pipelineStages.byId;

      return pipelineStages.map((pipelineStageId) => pipelineStagesById[pipelineStageId]);
    },
  },
  created() {
    this.fetchPipeline();
  },
  methods: {
    async fetchPipeline() {
      await this.$store.dispatch({
        type: 'ui/pipelines/read',
        pipelineUuid: this.pipelineUuid,
        params: {
          include: 'pipelineStages,cover',
        },
      });
    },
    handleDestroyed() {
      this.$router.replace({
        name: 'accounts.pipelines',
        params: {
          accountId: this.accountId,
        },
      });
    },
  },
};
</script>
